import mixin from '../../mixins/Mixin.js';
export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var modal = null;
  var self;
  domc.addType('image_media', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'image',
          config: JSON.stringify(config),
          tagName: 'div',
          src: '',
          width: '100%',
          height: '100%',
        }),
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') === 'image_media'
            ? this.view.el.outerHTML
            : '';
        },
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'image_media', src: el.src };
          }
          return result;
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'image_media', src: el.src };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      events: {
        // click: 'eventPostMessage',
        dblclick: 'openModal',
      },
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        this.listenTo(this.model, 'change:title', this.updateScript);
        modal = editor.Modal;
        modal.setTitle(config.translate['select_image-media']);
      },
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('img');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'image-media-' + mixin.methods.makeId();
          ifrm.style = 'width:100%;height:100%;border:none;overflow:hidden';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';
        self.openModal();
      },
      closeModal() {
        let iframeEl = document.getElementById('image-media-iframe');
        if (iframeEl) {
          iframeEl.style.display = 'none';
        }
        document.getElementById('CanvOverlay').style.display = 'none';
        this.handleEmptyImage();
      },
      setCloseImageModal(comp, id) {
        let self = this;
        if (document.getElementById('close-modal-' + id)) {
          document.getElementById('close-modal-' + id).addEventListener('click', function(e) {
            self.closeModal(comp, id);
          });
        }
      },
      openModal() {
        let iframeEl = document.getElementById('image-media-iframe');
        if (iframeEl) {
          iframeEl.style.display = 'block';
        }

        let conf = mixin.methods.getLangCode('display-image-plugin');
        this.model.set('config', conf);
        let id = 'image-media';
        self.setCloseImageModal('image_media', id);
        modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';
          self.handleEmptyImage();
        });
      },
      render(...args) {
        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
      handleEmptyImage() {
        const getAllComponents = (model, result = []) => {
          result.push(model);
          model.components().each(mod => getAllComponents(mod, result));
          return result;
        };
        const all = getAllComponents(editor.DomComponents.getWrapper());
        let found = all.some(c => c.attributes.type === 'image_media' && !c.attributes.src);
        while (found) {
          editor.UndoManager.undo();
          const all = getAllComponents(editor.DomComponents.getWrapper());
          found = all.some(c => c.attributes.type === 'image_media' && !c.attributes.src);
        }
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/image/components.js